const localeReducer = (state = 'en', action: any) => {
    switch (action.type) {
        case 'SET_LOCALE':
            return action.locale;
        default:
            return state;
    }
};

export default localeReducer;
